export { NavigationBottomEntityMobile } from './navigation-bottom';
